export default "__VITE_ASSET__0644fd89__"